export default __webpack_public_path__ + "DumpertDeluxeBanner-cb71c7.png";